import React, { useMemo, useState } from 'react';

import CompanyResource from 'app/components/CompanyResource';
import { FolderIcon } from 'app/components/shared/icons';
import useMetaTags from 'hooks/useMetaTags';

import { IResource } from '../../ResourceCard';
import { resolveResourceViewBehavior } from '../../resourceClickBehavior';
import {
  ResourcesDetailInlineCTAContainer,
  ResourcesDetailInlineCTAIcon,
  ResourcesDetailInlineCTAIconContainer,
  ResourcesDetailInlineCTAImage,
  ResourcesDetailInlineCTAImageContainer,
  ResourcesDetailInlineCTAName,
  ResourcesDetailInlineCTATitle,
  ResourcesDetailInlineCTAURL,
  ResourcesDetailInlineCTAURLContainer,
  ResourcesDetailInlineCTAURLImage,
  ResourcesDetailInlineCTAWrapper,
} from './styled';

export interface ResourcesDetailInlineCTAProps {
  resource: IResource;
}

export default function ResourcesDetailInlineCTA({ resource }: ResourcesDetailInlineCTAProps) {
  const [isFullScreen, setIsFullScreen] = useState(false);
  const { isLoading, data } = useMetaTags(resource?.link);

  const handleClick = () => {
    const viewBehavior = resolveResourceViewBehavior(resource);

    if (viewBehavior.canFullScreen) {
      setIsFullScreen(true);
      return;
    }

    return window.open(resource?.link, '_blank', 'noopener,noreferrer');
  };

  const linkDomain = useMemo(() => {
    if (!resource?.link) return '';

    if (resource.link.includes('amazonaws.com')) return 'os.kyu.com';

    const domain = resource.link
      ?.replace('http://', '')
      ?.replace('https://', '')
      ?.replace('www.', '')
      ?.split(/[/?#]/)[0];

    return domain;
  }, [resource?.link]);

  const favicon = useMemo(() => {
    if (!resource?.link) return '/icons/kyu.ico';

    if (resource?.link.includes('amazonaws.com')) return '/icons/kyu.ico';

    return (
      'https://s2.googleusercontent.com/s2/favicons?domain=' +
      resource?.link.replace('http://', '').replace('https://', '').split(/[/?#]/)[0]
    );
  }, [resource?.link]);

  return (
    <>
      <ResourcesDetailInlineCTAWrapper onClick={handleClick}>
        <ResourcesDetailInlineCTAImageContainer>
          {!isLoading && data?.img_url ? (
            <ResourcesDetailInlineCTAImage alt="Resource CTA Image" src={data?.img_url} />
          ) : (
            <ResourcesDetailInlineCTAIconContainer>
              <FolderIcon width={63} height={63} />
            </ResourcesDetailInlineCTAIconContainer>
          )}
        </ResourcesDetailInlineCTAImageContainer>
        <ResourcesDetailInlineCTAContainer>
          <ResourcesDetailInlineCTATitle>OPEN LINK</ResourcesDetailInlineCTATitle>
          <ResourcesDetailInlineCTAName>{resource?.title}</ResourcesDetailInlineCTAName>
          <ResourcesDetailInlineCTAURLContainer>
            <ResourcesDetailInlineCTAURLImage alt="Resource CTA Link Favicon" src={favicon} />
            <ResourcesDetailInlineCTAURL>{linkDomain}</ResourcesDetailInlineCTAURL>
          </ResourcesDetailInlineCTAURLContainer>
        </ResourcesDetailInlineCTAContainer>
      </ResourcesDetailInlineCTAWrapper>
      {isFullScreen ? (
        <CompanyResource resourceSlug={resource.slug} onClose={() => setIsFullScreen(false)} />
      ) : null}
    </>
  );
}
